export interface Mosque {
  id: string;
  name: string;
  type: 'mosque' | 'prayer_room' | 'hired_hall';
  isPublic: boolean;
  location: {
    lat: number;
    lng: number;
    address?: string;
  };
  facilities: {
    menWc: boolean | null;
    womenWc: boolean | null;
    menWudu: boolean | null;
    womenWudu: boolean | null;
    womenPrayerArea: boolean | null;
  };
  description?: string;
  sourceLink?: string;
  createdBy: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface MosquePhoto {
  id: string;
  mosqueId: string;
  url: string;
  storagePath: string;
  fileName: string;
  fileSize: number | null;
  mimeType: string | null;
  caption: string | null;
  displayOrder: number;
  status: 'pending' | 'approved' | 'rejected';
  createdAt: Date;
}

export interface PhotoUploadData {
  id: string;
  file: File;
  previewUrl: string;
  caption?: string;
}

export interface MosqueFormData {
  name: string;
  type: 'mosque' | 'prayer_room' | 'hired_hall';
  isPublic: boolean;
  location?: {
    lat: number;
    lng: number;
  };
  facilities: {
    menWc: boolean | null;
    womenWc: boolean | null;
    menWudu: boolean | null;
    womenWudu: boolean | null;
    womenPrayerArea: boolean | null;
  };
  description?: string;
  sourceLink?: string;
}

export const MOSQUE_TYPES = {
  mosque: { label: 'Mosque', color: '#6366f1' },
  prayer_room: { label: 'Prayer Room', color: '#14b8a6' },
  hired_hall: { label: 'Hired Hall', color: '#f59e0b' }
} as const;
